import React from "react";
import Sidebar from "./components/common/Sidebar";
import CanvasContainer from "./components/CanvasContainer";
import "./App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { PhotoProvider } from "./context/PhotoContext";

function App() {
  return (
    <LanguageProvider>
      <PhotoProvider>
        <div className="app-wrapper">
          <div className="main-layout">
            <Sidebar />
            <div className="canvas-section">
              <CanvasContainer />
            </div>
          </div>
        </div>
      </PhotoProvider>
    </LanguageProvider>
  );
}

export default App;
